import { DataTableCol } from "../../../components/tables/types";

export const cgpaDataGridCols: DataTableCol[] = [
    {
        title: 'Created Date',
        control: 'createdAt',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Email',
        control: 'emailAddress',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Expecting Cgpa',
        control: 'expectingCgpa',
        sortable: true,
        canShowColumn: true
    },
    {
        title: 'Actions',
        control: 'both',
        sortable: false,
        // isEdit: true,
        isDelete: true,
        isAccess:true,
        canShowColumn: true
    },
];